import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
  DEFAULT_SETTINGS_SECTION_ID,
  getSettingsNavItemById,
} from '@/data/settingsNavData'
import { buildSettingsSectionPath } from '@/routes/paths'

/**
 * Route + document title state for {@link SettingsPageContent} and {@link SettingsModal}.
 *
 * @param {{ sectionId?: string }} [options] When `sectionId` is passed (modal), skips route params.
 */
export function useSettingsPageModel(options = {}) {
  const { sectionId: routeSectionId } = useParams()
  const sectionId = options.sectionId ?? routeSectionId
  const item = useMemo(() => (sectionId ? getSettingsNavItemById(sectionId) : undefined), [sectionId])

  useEffect(() => {
    if (!item || options.sectionId !== undefined) return
    document.title = `${item.label} — Settings`
  }, [item, options.sectionId])

  return {
    item,
    isValidSection: Boolean(item),
    redirectPath: buildSettingsSectionPath(DEFAULT_SETTINGS_SECTION_ID),
  }
}
